import { calculateAverage } from 'utils/helpers';
import { Stack, Text, Group } from '@mantine/core';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useTranslation } from 'react-i18next';
import { BloodPressureChartOptions } from 'components/Charts/ChartOptions/BloodPressureOptions';
import { useBloodPressureOverview } from 'hooks/api/bloodpressure/useBloodPressureData';

interface BloodPressureChartProps {
  options?: Omit<Highcharts.Options, 'series' | 'loading'>;
}

export const BloodPressureChart = ({ options }: BloodPressureChartProps) => {
  const { t } = useTranslation();

  const { data, handleSelected, getItemByDate } = useBloodPressureOverview();

  const systolicAverage = calculateAverage(data.map((value) => parseInt(value.bloodPressure.split('/')[0], 10)));
  const diastolicAverage = calculateAverage(data.map((value) => parseInt(value.bloodPressure.split('/')[1], 10)));
  const pulsePressureAverage = calculateAverage(data.map((value) => value.pulsePressure));

  const bloodPressureOptions = BloodPressureChartOptions({
    data,
    onClickData: (date) => handleSelected(getItemByDate(date)),
    options,
  });

  const renderAverages = () => {
    if (data.length) {
      return (
        <Group justify={'center'}>
          <Text>
            <span style={{ fontWeight: 'bold' }}>{t('average_systolic_label')}</span>
            {': '}
            {Math.floor(systolicAverage)}
          </Text>
          <Text>
            <span style={{ fontWeight: 'bold' }}>{t('average_diastolic_label')}</span>
            {': '}
            {Math.floor(diastolicAverage)}
          </Text>
          <Text>
            <span style={{ fontWeight: 'bold' }}>{t('average_pulse_pressure_label')}</span>
            {':'} {Math.floor(pulsePressureAverage)}
          </Text>
        </Group>
      );
    }

    return null;
  };

  return (
    <Stack gap={'md'} pt={10}>
      <HighchartsReact highcharts={Highcharts} options={bloodPressureOptions} />
      {renderAverages()}
    </Stack>
  );
};
